import { render, staticRenderFns } from "./solicitacao-consulta-credito.vue?vue&type=template&id=407fb54c&scoped=true"
import script from "./solicitacao-consulta-credito.vue?vue&type=script&lang=js"
export * from "./solicitacao-consulta-credito.vue?vue&type=script&lang=js"
import style0 from "./solicitacao-consulta-credito.vue?vue&type=style&index=0&id=407fb54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407fb54c",
  null
  
)

export default component.exports